module.exports = __webpack_public_path__ + "media/images/tmp/ig5-8dcb81c738b99ecba4f862a5a42137ef.png";